import { useNavigate } from "react-router-dom";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Crown, ChevronDown, Bell, Menu, Shield } from "lucide-react";

export function MobileHeader({ user, theme, unreadCount, onToggleNotifs, onOpenSidebar }) {
  const navigate = useNavigate();

  return (
    <div
      // Iter174 — iOS safe-area: extend the header UNDER the notch/Dynamic Island
      // and pad the top so the actual content sits below the system bar.
      // `pt-[env(safe-area-inset-top)]` on iPhone gives ~44px of top inset;
      // regular browsers ignore it. `h-14` is the interactive band, added to
      // the safe-area inset for total height.
      style={{ paddingTop: "env(safe-area-inset-top)" }}
      className={`lg:hidden fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-3 ${theme === "light" ? "bg-white border-gray-200" : "bg-[#0f0f10] border-white/5"} border-b`}
    >
      <div className="h-14 w-full flex items-center justify-between">
        <button
          onClick={onOpenSidebar}
          // Iter174 — 44×44 tap target (Apple HIG minimum) — was p-2/40x40.
          className={`min-w-11 min-h-11 flex items-center justify-center rounded-lg ${theme === "light" ? "hover:bg-gray-100 active:bg-gray-200" : "hover:bg-white/10 active:bg-white/15"} transition-colors`}
          aria-label="Open menu"
          data-testid="mobile-menu-btn"
        >
          <Menu className={`w-6 h-6 ${theme === "light" ? "text-gray-900" : "text-white"}`} />
        </button>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button
              className={`flex items-center gap-2 min-h-11 px-2 rounded-lg ${theme === "light" ? "hover:bg-gray-100 active:bg-gray-200" : "hover:bg-white/10 active:bg-white/15"} transition-colors`}
              aria-label="Switch dashboard"
              data-testid="mobile-dashboard-switcher"
            >
              <Crown className="w-6 h-6 text-emerald-600" />
              <span className={`text-lg font-bold font-heading italic ${theme === "light" ? "text-gray-900" : "text-white"}`}>WarMap</span>
              <ChevronDown className={`w-4 h-4 ${theme === "light" ? "text-gray-500" : "text-gray-400"}`} />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="center" className={`${theme === "light" ? "bg-white border-gray-200" : "bg-[#1A1A1A] border-white/10"}`}>
            <DropdownMenuItem
              onClick={() => navigate("/dashboard")}
              className={`cursor-pointer ${theme === "light" ? "text-gray-900" : "text-white"} bg-emerald-500/20`}
            >
              Sales Dashboard
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={() => navigate("/marketing")}
              className={`cursor-pointer ${theme === "light" ? "text-gray-900" : "text-white"}`}
            >
              Marketing Dashboard
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
        <div className="flex items-center gap-0.5">
          {user?.role === "superadmin" && (
            <button
              onClick={() => navigate("/superadmin/dashboard")}
              data-testid="mobile-superadmin-btn"
              aria-label="Super admin"
              className={`min-w-11 min-h-11 flex items-center justify-center rounded-lg ${theme === "light" ? "hover:bg-gray-100 active:bg-gray-200" : "hover:bg-white/10 active:bg-white/15"} transition-colors`}
            >
              <Shield className="w-5 h-5 text-red-400" />
            </button>
          )}
          <button
            onClick={onToggleNotifs}
            className={`relative min-w-11 min-h-11 flex items-center justify-center rounded-lg ${theme === "light" ? "hover:bg-gray-100 active:bg-gray-200" : "hover:bg-white/10 active:bg-white/15"} transition-colors`}
            aria-label={unreadCount > 0 ? `${unreadCount} unread notifications` : "Notifications"}
            data-testid="mobile-notification-btn"
          >
            <Bell className={`w-5 h-5 ${theme === "light" ? "text-gray-600" : "text-gray-400"}`} />
            {unreadCount > 0 && (
              <span className="absolute top-1.5 right-1.5 min-w-[18px] h-[18px] bg-red-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center px-1">
                {unreadCount > 9 ? "9+" : unreadCount}
              </span>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
